import {useContext, useEffect, useRef, useState} from "react"
import {NavLink, useParams} from "react-router-dom"
import {InputText} from "primereact/inputtext"
import {InputTextarea} from "primereact/inputtextarea"
import {Button} from "primereact/button"
import {Dropdown} from "primereact/dropdown"
import {Calendar} from "primereact/calendar"
import {Divider} from "primereact/divider"
import moment from "moment"
import {useImmer} from "use-immer"
import commonStyles from "../../common.module.css"
import api from "../../../api"
import userContext from "../../../context/userContext"
import useMachines from "../../../hook/useMachines"
import useTeams from "../../../hook/useTeams"
import useTaskRepeated from "../../../hook/useTaskRepeated"
import useTaskTags from "../../../hook/useTaskTags"
import backConfirmation from "../../../function/backConfirmation"
import confirmation from "../../../function/confirmation"
import useTaskStates from "../../../hook/useTaskStates"
import FileList from "../../File/FileList"
import WarehouseItemForm from "../WarehouseItemForm"
import TaskHistory from "../TaskHistory"

export default function TaskPreventionForm() {
  const {uuid} = useParams()
  const machines = useMachines()
  const teams = useTeams()
  const back = () => window.history.back()
  const user = useContext(userContext)
  const refBtnSave = useRef(null)

  const [state, setState] = useState("OPEN")
  const [name, setName] = useState("")
  const handleNameChange = (e) => setName(e.target.value)
  const [description, setDescription] = useState("")
  const handleDescriptionChange = (e) => setDescription(e.target.value)
  const repeatedOptions = useTaskRepeated()
  const [repeated, setRepeated] = useState("")
  const [repeatedValue, setRepeatedValue] = useState(1)
  const handleRepeatedValueChange = (e) => {
    const value = parseInt(e.target.value, 10)
    if (!isNaN(value)) {
      setRepeatedValue(value)
    }
  }
  const handleRepeatedChange = (e) => setRepeated(e.target.value)
  const [startsAt, setStartsAt] = useState("")
  const handleStartsAtChange = (e) => setStartsAt(e.target.value)
  const [machine, setMachine] = useState("")
  const handleMachineChange = (e) => setMachine(e.target.value)
  const [team, setTeam] = useState("")
  const handleTeamChange = (e) => setTeam(e.target.value)
  const taskTagOptions = useTaskTags()
  const [tag, setTag] = useState("")
  const handleTagChange = (e) => setTag(e.target.value)
  const [subTaskDescription, setSubTaskDescription] = useState("")
  const [order, setOrder] = useState("")
  const handleOrderChange = (e) => setOrder(e.target.value)

  const [someSubTaskWithoutPosition, setSomeSubTaskWithoutPosition] = useState(false)
  const [editedSubTaskPosition, setEditedSubTaskPosition] = useState(null)
  const handleSubTaskDescriptionChange = (e) => setSubTaskDescription(e.target.value)
  const [subTaskValueDescription, setSubTaskValueDescription] = useState("")
  const handleSubTaskValueDescriptionChange = (e) => setSubTaskValueDescription(e.target.value)
  const [subTaskValueUnit, setSubTaskValueUnit] = useState("")
  const handleSubTaskValueUnitChange = (e) => setSubTaskValueUnit(e.target.value)
  const [subTasks, setSubTasks] = useImmer([])
  const addSubTask = () => {
    setSubTasks((draft) => {
      draft.push({
        description: subTaskDescription,
        value_description: subTaskValueDescription,
        value_unit: subTaskValueUnit,
        position: subTasks.length + 1,
      })
    })

    setSubTaskDescription("")
    setSubTaskValueDescription("")
    setSubTaskValueUnit("")
  }

  const moveSubTaskUp = (index) => {
    if (index > 1) {
      setSubTasks((draft) => {
        let prev = draft.find((subTask) => subTask.position === index - 1)
        let curr = draft.find((subTask) => subTask.position === index)

        prev.position = index
        curr.position = index - 1

        draft.sort((a, b) => a.position - b.position)
      })
    }
  }

  const moveSubTaskUpAsync = async (index) => {
    if (index > 1) {
      const prev = subTasks.find((subTask) => subTask.position === index - 1)
      const curr = subTasks.find((subTask) => subTask.position === index)

      const prevPayload = {
        uuid: prev.uuid,
        description: prev.description,
        value_description: prev.value_description || "",
        value_unit: prev.value_unit || "",
        position: index,
      }

      const currPayload = {
        uuid: curr.uuid,
        description: curr.description,
        value_description: curr.value_description || "",
        value_unit: curr.value_unit || "",
        position: index - 1,
      }

      await api.post(`/tasks/${uuid}/sub/${prev.uuid}`, prevPayload)
      await api.post(`/tasks/${uuid}/sub/${curr.uuid}`, currPayload)

      refresh()
    }
  }

  const moveSubTaskDown = (index) => {
    if (index < subTasks.length) {
      setSubTasks((draft) => {
        let next = draft.find((subTask) => subTask.position === index + 1)
        let curr = draft.find((subTask) => subTask.position === index)

        next.position = index
        curr.position = index + 1

        draft.sort((a, b) => a.position - b.position)
      })
    }
  }

  const moveSubTaskDownAsync = async (index) => {
    if (index < subTasks.length) {
      const next = subTasks.find((subTask) => subTask.position === index + 1)
      const curr = subTasks.find((subTask) => subTask.position === index)

      const nextPayload = {
        uuid: next.uuid,
        description: next.description,
        value_description: next.value_description || "",
        value_unit: next.value_unit || "",
        position: index,
      }

      const currPayload = {
        uuid: curr.uuid,
        description: curr.description,
        value_description: curr.value_description || "",
        value_unit: curr.value_unit || "",
        position: index + 1,
      }

      await api.post(`/tasks/${uuid}/sub/${next.uuid}`, nextPayload)
      await api.post(`/tasks/${uuid}/sub/${curr.uuid}`, currPayload)

      refresh()
    }
  }

  const removeSubTask = (index) => {
    setSubTasks(() => {
      let newDraft = []

      subTasks.forEach((subTask) => {
        if (subTask.position !== index)
          newDraft.push(Object.assign({}, subTask))
      })

      newDraft.forEach((subTask, i) => {
        subTask.position = i + 1
      })

      return newDraft
    })
  }

  const handleEditSubTaskClick = (index) => {
    setEditedSubTaskPosition(index)

    const subTask = subTasks.find((subTask) => subTask.position === index)

    setSubTaskDescription(subTask.description || "")
    setSubTaskValueDescription(subTask.value_description || "")
    setSubTaskValueUnit(subTask.value_unit || "")
  }

  const editSubTask = () => {
    setSubTasks((draft) => {
      const subTask = draft.find((subTask) => subTask.position === editedSubTaskPosition)

      subTask.description = subTaskDescription
      subTask.value_description = subTaskValueDescription
      subTask.value_unit = subTaskValueUnit
    })

    // reset
    setSubTaskDescription("")
    setSubTaskValueDescription("")
    setSubTaskValueUnit("")
    setEditedSubTaskPosition(null)
  }

  const editSubTaskAsync = async () => {
    const subTask = subTasks.find((subTask) => subTask.position === editedSubTaskPosition)
    const payload = {
      uuid: subTask.uuid,
      description: subTaskDescription,
      value_description: subTaskValueDescription,
      value_unit: subTaskValueUnit,
    }

    await api.post(`/tasks/${uuid}/sub/${subTask.uuid}`, payload)

    // reset
    setSubTaskDescription("")
    setSubTaskValueDescription("")
    setSubTaskValueUnit("")
    setEditedSubTaskPosition(null)
    refresh()
  }

  const [history, setHistory] = useState([])

  const [files, setFiles] = useState([])
  const handleFilesChange = (changedFiles) => setFiles(changedFiles)

  const [refresher, setRefresher] = useState(false)
  const refresh = () => setRefresher(!refresher)

  const [isLoading, setIsLoading] = useState(false)

  const taskStates = useTaskStates()
  const getTaskStateName = () => taskStates.length && state
    ? taskStates.find((taskState) => taskState.value === state).name
    : ""

  const create = () => {
    setIsLoading(true)

    const payload = {
      type: "PREVENTION",
      // operation is not editable trough UI, but we need operation to filter task for users
      // because task is given by combination "operation" and "team"
      operation: user.user.operation.uuid,
      name, description, repeated, team, machine, files,
      starts_at: moment(startsAt).format("YYYY-MM-DD"), tag,
      tasks: subTasks, order,
    }

    if (repeated === "DAILY_INTERVAL") {
      payload.repeated_value = repeatedValue
    }

    api
      .put("/tasks", payload)
      .then(back)
      .finally(() => setIsLoading(false))
  }

  const close = () => api
    .patch(`/tasks/${uuid}/close`, {})
    .then(back)
  const closeConfirmation = (e) => confirmation(e.currentTarget, "Opravdu uzavřít?", close)

  const handleFormSubmit = (e) => {
    e.preventDefault()
    if (uuid && e.nativeEvent.submitter.value !== "save-as-new") {
      editConfirmation()
    } else {
      create()
    }
  }
  const handleCloseAndFormSubmit = async () => {
    await api.patch(`/tasks/${uuid}/close`, {})
    create()
  }
  const editConfirmation = () => confirmation(refBtnSave.current,
    "Tato údržba se uzavře a bude vytvořena nová. Pokračovat?", handleCloseAndFormSubmit)

  useEffect(() => {
    if (uuid) {
      api.get(`/tasks/${uuid}`)
        .then(({data}) => {
          setState(data.data.state)
          setName(data.data.name)
          setDescription(data.data.description)
          setRepeated(data.data.repeated)
          setRepeatedValue(data.data.repeated_value || 1)
          setStartsAt(moment(data.data.starts_at).toDate())
          setMachine(data.data.machine.uuid)
          setTeam(data.data.team.uuid)
          setTag(data.data.tag ? data.data.tag.uuid : "")
          setSomeSubTaskWithoutPosition(data.data.tasks.some((subTask) => !subTask.position))
          setSubTasks(() => {
            data.data.tasks.forEach((subTask, index) => {
              if (!subTask.position) {
                subTask.position = index + 1
              }
            })
            return data.data.tasks
          })
          setFiles(data.data.files || [])
          setHistory(data.data.history)
          setOrder(data.data.order || "")
        })
    }
  }, [uuid, refresher, setSubTasks])

  return (
    <userContext.Consumer>
      {({hasPerm}) => (
        <>
          <form className={"col-12 md:col-6"} onSubmit={handleFormSubmit}>
            <div className={"p-fluid"}>
              <div className={"field"}>
                <label>Aktuální stav:</label>
                <InputText value={getTaskStateName(state)} disabled={true}/>
              </div>

              <div className={"field"}>
                <label className={commonStyles.labelRequired}>Název:</label>
                <InputText required={true} value={name} onChange={handleNameChange} maxLength={30}/>
                <small className={commonStyles.fieldHelp}>{30 - name.length} znaků zbývá.</small>
              </div>

              <div className={"field"}>
                <label className={commonStyles.labelRequired}>Detailní popis:</label>
                <InputTextarea required={true} value={description} rows={5}
                               onChange={handleDescriptionChange}/>
              </div>

              <div className={"field"}>
                <label className={commonStyles.labelRequired}>Opakování:</label>
                <Dropdown required={true} value={repeated} options={repeatedOptions}
                          optionValue={"value"} optionLabel={"name"} emptyMessage={"Žádné záznamy"}
                          onChange={handleRepeatedChange}/>
              </div>

              {repeated === "DAILY_INTERVAL" && (
                <div className={"field"}>
                  <label className={commonStyles.labelRequired}>Počet dní:</label>
                  <InputText type={"number"} required={repeated === "DAILY_INTERVAL"}
                             value={repeatedValue} min={1} onChange={handleRepeatedValueChange}/>
                  <small className={commonStyles.fieldHelp}>Opakovat
                    každých {repeatedValue} dní.</small>
                </div>
              )}

              <div className={"field"}>
                <label className={commonStyles.labelRequired}>Začátek opakování:</label>
                <Calendar value={startsAt} dateFormat={"dd. mm. yy"} onChange={handleStartsAtChange}
                          showTime={true} hourFormat={24} hideOnDateTimeSelect={true}/>
              </div>

              <div className={"field"}>
                <label className={commonStyles.labelRequired}>Stroj:</label>
                <Dropdown required={true} value={machine} options={machines} optionValue={"uuid"}
                          optionLabel={"name"} emptyMessage={"Žádné záznamy"}
                          onChange={handleMachineChange}/>
              </div>

              <div className={"field"}>
                <label className={commonStyles.labelRequired}>Odpovědný tým:</label>
                <Dropdown required={true} value={team} options={teams} optionValue={"uuid"}
                          optionLabel={"name"} emptyMessage={"Žádné záznamy"}
                          onChange={handleTeamChange}/>
              </div>

              <div className={"field"}>
                <label>Typ:</label>
                <Dropdown value={tag} options={taskTagOptions} optionValue={"uuid"}
                          optionLabel={"name"} emptyMessage={"Žádné záznamy"}
                          onChange={handleTagChange}/>
                <small className={commonStyles.fieldHelp}>Označení úkolu. Slouží k filtrování v
                  přehledu úkolů.</small>
              </div>

              <div className={"field"}>
                <label>Zakázka:</label>
                <InputText value={order} onChange={handleOrderChange}/>
              </div>

              <Divider>Úkoly:</Divider>
              {subTasks.length === 0 && <p>Źádné úkoly.</p>}

              <ul className={"pl-4"}>
                {subTasks.map((subTask) => (
                  <li key={subTask.description}>
                    <div className={"flex align-items-center"}>
                      {subTask.description}

                      {subTask.value_description && (
                        <small className={"text-sm ml-1"}>
                          ({subTask.value_description}/{subTask.value_unit})
                        </small>
                      )}

                      <div className={"py-1 ml-auto"}>
                        <Button className={"p-button-text p-1"}
                                icon={"pi pi-arrow-up"}
                                tooltip={"Posunout o pozici výše"}
                                type={"button"}
                                disabled={someSubTaskWithoutPosition}
                                onClick={() => uuid
                                  ? moveSubTaskUpAsync(subTask.position)
                                  : moveSubTaskUp(subTask.position)}/>

                        <Button className={"p-button-text p-1"}
                                icon={"pi pi-arrow-down"}
                                tooltip={"Posunout o pozici níže"}
                                type={"button"}
                                disabled={someSubTaskWithoutPosition}
                                onClick={() => uuid
                                  ? moveSubTaskDownAsync(subTask.position)
                                  : moveSubTaskDown(subTask.position)}/>

                        <Button className={"p-button-text p-1"}
                                icon={"pi pi-pencil"}
                                tooltip={"Upravit"}
                                type={"button"}
                                onClick={() => handleEditSubTaskClick(subTask.position)}/>

                        <Button className={"p-button-text p-1 p-button-danger"}
                                icon={"pi pi-times"}
                                tooltip={"Smazat"}
                                type={"button"}
                                onClick={() => removeSubTask(subTask.position)}/>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>

              <Divider className={"font-normal"}>{editedSubTaskPosition ? "Aktualizovat" : "Nový"} úkol:</Divider>
              <div className={"field"}>
                <label>Popis:</label>
                <InputText value={subTaskDescription} onChange={handleSubTaskDescriptionChange}
                           placeholder={"Popis"}/>
              </div>

              <div className={"field"}>
                <label>Sledovaná hodnota:</label>
                <div className={"p-inputgroup"}>
                  <InputText value={subTaskValueDescription}
                             onChange={handleSubTaskValueDescriptionChange} placeholder={"Název"}
                             disabled={uuid && editedSubTaskPosition && !subTaskValueDescription}/>
                  <InputText value={subTaskValueUnit} onChange={handleSubTaskValueUnitChange}
                             placeholder={"Jednotka"}
                             disabled={uuid && editedSubTaskPosition && !subTaskValueUnit}/>
                </div>
                <small className={commonStyles.fieldHelp}>Zadejte pouze v případě, že chcete aby
                  pracovník vyplňoval proměnnou veličinu (např. velikost nákolku kola
                  jeřábu).</small>
              </div>
            </div>

            <Button className={"p-button-raised p-button-text ml-1 mb-3"}
                    type={"button"}
                    disabled={!subTaskDescription}
                    label={editedSubTaskPosition ? "Aktualizovat úkol" : "Přidat úkol"}
                    onClick={editedSubTaskPosition
                      ? uuid
                        ? editSubTaskAsync
                        : editSubTask
                      : addSubTask}/>

            <div className={"flex"}>
              <Button type={"button"} label={"Zpět"} className={"p-button-warning m-1"}
                      onClick={uuid ? back : backConfirmation}/>
              <div className={"ml-auto"}>
                <Button type={"button"} label={"Uzavřít"} className={"p-button-danger m-1"}
                        onClick={closeConfirmation} disabled={!uuid || state !== "OPEN"}/>
                <NavLink to={`/task/prevention/${uuid}/subtasks`}
                         className={`p-button m-1 ${uuid ? "" : "p-disabled"}`}>Zobrazit
                  stav podúkolů</NavLink>
                <Button type={"submit"} label={"Uložit"} className={"m-1"} ref={refBtnSave}
                        disabled={!hasPerm("ROLE_PERM_PREVENTION_WRITE")}/>
                {uuid && (
                  <Button type={"submit"} label={"Uložit novou"} className={"m-1"}
                          icon={isLoading ? "pi pi-spin pi-spinner" : ""}
                          disabled={isLoading || !hasPerm("ROLE_PERM_PREVENTION_WRITE")}
                          value={"save-as-new"}/>
                )}
              </div>
            </div>
          </form>

          <div className={"col-12 md:col-6"}>
            <FileList files={files} onChange={uuid ? refresh : handleFilesChange}
                      entityUrl={uuid ? `/tasks/${uuid}` : ""}
                      isDisabled={!hasPerm("ROLE_PERM_PREVENTION_WRITE")}/>
            {uuid && (
              <>
                <TaskHistory history={history} taskType={"prevention"}/>
                <WarehouseItemForm taskUuid={uuid} onChange={refresh} taskType={"prevention"}/>
              </>
            )}
          </div>
        </>
      )}
    </userContext.Consumer>
  )
}
